import { render, staticRenderFns } from "./AppDownFile.vue?vue&type=template&id=64c5bde4&scoped=true"
import script from "./AppDownFile.vue?vue&type=script&lang=js"
export * from "./AppDownFile.vue?vue&type=script&lang=js"
import style0 from "./AppDownFile.vue?vue&type=style&index=0&id=64c5bde4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5bde4",
  null
  
)

export default component.exports